import ComicCard from "@/components/base/ComicCard";
import { allComics } from "@/mocks/comics";

export default function PopularComics() {
  const popular = [...allComics]
    .sort((a, b) => b.views - a.views)
    .slice(0, 5);

  return (
    <section className="py-10 md:py-14">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-6">
          人气排行
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {popular.map((comic, idx) => (
            <div key={comic.id} className="relative">
              <span className="absolute -top-2 -left-2 z-10 w-7 h-7 flex items-center justify-center rounded-full bg-accent-500 text-background-50 text-xs font-bold">
                {idx + 1}
              </span>
              <ComicCard comic={comic} size="medium" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}